import { Typography } from "@sunday/component";
import styled from "styled-components";

export const RefundPolicyPageContainer = styled.main`
  --color-text-ci: var(--colors-system-primitive-color-ic-blueneon-50, #435dff);
  --typography-bg-color-selection: var(--color-text-ci);
  --typography-color-selection: var(--color-text-on-primary, #ffffff);
  --typescale-font-head: var(--typeface-font-ic-en, "JUST Sans"),
    var(--typeface-font-ic-th, "Noto Sans Thai"), sans-serif;
  --typescale-font-base: var(--typeface-font-ic-th, "Noto Sans Thai"),
    var(--typeface-font-ic-en, "JUST Sans"), sans-serif;

  background: var(--color-surface-primary, #ffffff);

  && *::selection {
    background-color: var(--typography-bg-color-selection) !important;
    color: var(--typography-color-selection) !important;
  }
`;

export const RefundPolicyContentContainer = styled.div`
  width: 100%;
  max-width: 1388px;
  margin: 0 auto;
  padding: 80px 0;

  @media (max-width: 767px) {
    padding: 40px 16px 80px;
  }
`;

export const RefundPolicyContent = styled.div`
  width: 100%;
  max-width: 803px;
  margin: 0 auto;
`;

export const RefundPolicyTitle = styled(Typography.Display).attrs({
  designLevel: 3,
  weight: "bold",
  level: 1,
})`
  && {
    display: block;
    margin: 0 0 24px;
    color: var(--color-text-primary, #202123);
    font-style: normal;
    word-break: break-word;
  }

  @media (max-width: 767px) {
    && {
      --typography-d3-font-size: var(--typescale-size-h-1, 28px);
      --typography-d3-line-height: var(--typescale-line-height-h-1, 36px);
    }
  }
`;

export const RefundPolicyArticle = styled.article`
  --typography-color: var(--color-text-secondary, #5f6468);

  color: var(--color-text-secondary, #5f6468);
  word-break: break-word;
`;

export const RefundPolicySectionContainer = styled.section`
  margin: 0 0 24px;
`;

export const RefundPolicyHeading = styled.h2`
  margin: 0;
`;

export const RefundPolicySectionTitle = styled(Typography.Body).attrs({
  designLevel: 2,
  weight: "bold",
})`
  && {
    display: block;
  }
`;

export const RefundPolicyParagraph = styled.p`
  margin: 0;

  &[data-contact="true"] {
    margin-bottom: 24px;
  }
`;

export const RefundPolicyBodyText = styled(Typography.Body).attrs({
  designLevel: 2,
  weight: "regular",
})`
  && {
    color: inherit;
  }
`;

export const RefundPolicyLink = styled(Typography.Hyperlink).attrs({
  designLevel: 2,
  weight: "bold",
})`
  && {
    --typography-color: var(--color-text-ci, #435dff);
    --typography-hyperlink-color-hover: var(--color-text-ci, #435dff);

    text-decoration-skip-ink: none;
    text-underline-position: from-font;
  }
`;

export const RefundPolicyList = styled.ul`
  margin: 0;
  padding-left: 22px;
`;

export const RefundPolicyListItem = styled.li`
  margin: 0;
  padding: 0;
`;
